module.exports = __webpack_public_path__ + "static/media/ChecksDataScreen.40512720.png";